import { Link, createFileRoute } from "@tanstack/react-router"
import { ArrowRight, Check, LockKeyhole } from "lucide-react"
import { PERMISSION_MATRIX, ROLE_LABELS, type Role } from "@vienna/contracts"
import { Button } from "@/components/ui/button"
import { DataTable, Heading, Hint } from "@/components/workspace/primitives"
import { useWorkspaceContext } from "@/lib/session"

export const Route = createFileRoute("/w/$workspace/settings/roles")({ component: Permissions })

const COLUMNS: Role[] = ["admin", "marketing", "support_manager", "agent"]

/** Screen 41. The matrix is the one the API enforces, rendered from the shared contract. */
function Permissions() {
  const { workspace } = useWorkspaceContext()
  return (
    <>
      <Heading
        title="Roles & permissions"
        description="Access that matches each person’s responsibilities."
        action={
          <Button variant="outline" asChild>
            <Link to="/w/$workspace/settings/team" params={{ workspace: workspace.slug }}>
              Manage team
              <ArrowRight />
            </Link>
          </Button>
        }
      />
      <Hint title="One person can run the whole workspace">An Admin has access to support, marketing and workspace management. Standard roles keep responsibilities clear as the team grows.</Hint>
      <div className="ws-permissions-table">
        <DataTable
          heads={["Permission", ...COLUMNS.map((role) => ROLE_LABELS[role])]}
          rowKeys={PERMISSION_MATRIX.map((row) => row.permission)}
          rows={PERMISSION_MATRIX.map((row) => [
            row.label,
            ...COLUMNS.map((role) =>
              row.roles.includes(role) ? (
                <span className="ws-allowed" aria-label="Allowed">
                  <Check size={16} />
                </span>
              ) : (
                <span className="ws-not-allowed" aria-label="Not allowed">
                  —
                </span>
              )
            ),
          ])}
        />
      </div>
      <p className="ws-hint mt-5 flex gap-2">
        <LockKeyhole size={15} />
        Only the current owner can transfer workspace ownership.
      </p>
    </>
  )
}
